<app-header [account]="account"></app-header>
<main class="background-color-white main-container">
  <div class="bolt-container print-width">
    <div class="bolt-row wrapper">
            <div [ngClass]="{
            'bolt-col bolt-col-lg-12': true,
            'with-navigation': showNavigation && session,
            'deep-link': !showNavigation && session && deepLink
          }">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</main>
@if (sessionIdleWarningModalShow) {
  <tpi-notification-modal>
    <ng-container modalWarning>
      <bolt-modal primarybutton="Keep working" type="warning" secondarybutton="Log out" (bolt-modal-primary-button-click)="closeIdleModal()"
        (bolt-modal-secondary-button-click)="redirectToLogoutPage()" id="warningModal" heading="Do you want to keep working?" open=true>
        <p>
          For your security, your Nationwide online session will expire in approximately 3 minutes. What would you
          like to do?
        </p>
      </bolt-modal>
    </ng-container>
  </tpi-notification-modal>
}
@if (sessionExpireWarningModalShow) {
  <tpi-notification-modal>
    <ng-container modalWarning>
      <bolt-modal primarybutton="Keep working" type="warning" secondarybutton="Log out" (bolt-modal-primary-button-click)="closeExpireModal()"
        (bolt-modal-secondary-button-click)="redirectToLogoutPage()" id="expireModal" heading="Do you want to keep working?" open=true>
        <p>
          For security reasons, you will be logged out of your Nationwide online session in <b>approximately 5 minutes</b>.
          <br>
            Please finish any remaining work before your session expires and you are logged out.
            <br>
              You’ll have the ability to log in again if needed.
            </p>
          </bolt-modal>
        </ng-container>
      </tpi-notification-modal>
    }
    @if (session || !showNavigation) {
      <footer>
        <app-footer>
        </app-footer>
      </footer>
    }